import React from 'react';
import defLogo from '../../img/user.png';

function ChatCard(props) {

  const { users, messages, myId, unreadMessages } = props;

  return (
    <div>
      {
        users.map((user, i) => {
          return (
            <div key={i}>
              {
                myId !== user._id &&
                <div className="chat-container-card">
                  {
                    unreadMessages > 9 ?
                    <span className="chat-container-new-message">9+</span> :
                    unreadMessages > 0 ?
                    <span className="chat-container-new-message">{unreadMessages}</span> : null
                  }
                  <div className="chatUserIconContainer">
                    <img src={user.logo || defLogo} className="chatUserIcon" alt="Foto de perfil del usuario" />
                  </div>
                  <div className="chatUserName">{user.firstName} {user.lastName}{user.label ? ` - ${user.label}` : ''}</div>
                  <div className="chatLastMessage">{messages.length > 0 ? messages[messages.length - 1].message : null}</div>
                </div>
              }
            </div>
          )
        })
      }
    </div>
  );
}

export default ChatCard;
